import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BellIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M6.335 13.4A2.58 2.58 0 0 0 8 14a2.58 2.58 0 0 0 1.665-.6m2.111-7.8a3.52 3.52 0 0 0-1.106-2.546A3.87 3.87 0 0 0 8 2c-1.001 0-1.962.38-2.67 1.054A3.52 3.52 0 0 0 4.224 5.6c0 1.854-.49 3.124-1.039 3.963-.462.708-.693 1.063-.685 1.162.01.109.034.15.126.216.084.059.46.059 1.213.059h8.322c.753 0 1.13 0 1.213-.06.092-.064.116-.106.126-.215.008-.1-.223-.453-.685-1.162-.548-.84-1.039-2.109-1.039-3.963" /></svg>
  );
}

export default BellIcon;
